// extracted by mini-css-extract-plugin
module.exports = {"tab-content":"tab-content-df7S8RZ"};